// Status ID constants from API
// 21 -> Charged, 26,27,22,34 -> Failed, 28,20,33,23 -> Pending, rest -> Processing
export const STATUS_IDS = {
  CHARGED: [21],
  FAILED: [22, 26, 27, 34],
  PENDING: [20, 23, 28, 33],
} as const;

export type PaymentStatus = 'CHARGED' | 'PENDING' | 'FAILED' | 'PROCESSING';

export const isStatusId = (
  statusId: number,
  statusList: readonly number[],
): boolean => statusList.includes(statusId);

export const getPaymentStatus = (
  statusId: number | undefined,
): PaymentStatus => {
  if (statusId === undefined) {
    return 'PROCESSING';
  }
  if (isStatusId(statusId, STATUS_IDS.CHARGED)) {
    return 'CHARGED';
  }
  if (isStatusId(statusId, STATUS_IDS.FAILED)) {
    return 'FAILED';
  }
  if (isStatusId(statusId, STATUS_IDS.PENDING)) {
    return 'PENDING';
  }
  return 'PROCESSING';
};

export const isTerminalStatus = (statusId: number | undefined): boolean => {
  if (statusId === undefined) {
    return false;
  }
  return (
    isStatusId(statusId, STATUS_IDS.CHARGED) ||
    isStatusId(statusId, STATUS_IDS.FAILED)
  );
};
